import { connect } from 'react-redux';
import { ProductPopup as ProductPopupUi } from 'app/components/product/ProductPopup';
import {
  selectedProductsSelector,
  showExtendedProductsInfoSelector,
  focusedPartSelector,
} from 'app/store/selectors';
import { StoreState } from 'app/models/types';
import { updateProductQuantity } from 'app/store/thunk/product';
import { updateFocusedPart } from 'app/store/reducers/ui';

const mapStateToProps = (state: StoreState) => ({
  selectedProducts: selectedProductsSelector(state),
  showExtendedProductsInfo: showExtendedProductsInfoSelector(state),
  focusedPart: focusedPartSelector(state),
});

const mapDispatchToProps = {
  onSetProductQuantity: updateProductQuantity,
  onChangeFocusedPart: updateFocusedPart,
};

// @ts-expect-error test
export const ProductPopup = connect(mapStateToProps, mapDispatchToProps)(ProductPopupUi);
